import Vue from 'vue';
import Router from 'vue-router';
import ChatArea from './components/ChatArea';
import Login from './components/member/Login';
import storage from './api/storage';
import config from './config/config.json';

Vue.use(Router);

const requireAuth = role => (to, from, next) => {
	if (config.LOGIN_USE) {
		const userData = storage.getUserData();
		if (userData && userData.mbrId) {
			if (role && userData.role !== 'ADMIN') {
				alert('접근 권한이 없습니다.');
				return next('/');
			}
			return next();
		}
		return next('/login');
	} else {
		return next();
	}
};

export default new Router({
	routes: [
		{
			path: '/',
			name: 'ChatArea',
			component: ChatArea,
			beforeEnter: requireAuth(),
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			beforeEnter: function(to, from, next) {
				// user 정보가 없을 때만 로그인 페이지로 이동
				if (storage.getUserData()) {
					return next('/');
				}
				return next();
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/router.js